import { HADifferenceItem } from "../../create/HADifferenceModal";
import { Button, Flex } from "@chakra-ui/react";
import { AppColors } from "@/styles/colors";
import { Check } from "lucide-react";
import { Dispatch, SetStateAction } from "react";

interface Props {
  haDifferenceMotivosValid: boolean;
  motivosDesvio: HADifferenceItem[];
  setOpenHADifferenceModal: Dispatch<SetStateAction<boolean>>;
  loadingCreate: boolean;
  haDifferenceAbs: number;
}

export const HADifferenceDisplay = ({
  haDifferenceMotivosValid,
  motivosDesvio,
  setOpenHADifferenceModal,
  loadingCreate,
  haDifferenceAbs,
}: Props) => {
  return (
    <Flex paddingTop="16px">
      {haDifferenceMotivosValid && (motivosDesvio?.length ?? 0) > 0 ? (
        <Flex gap="16px">
          <Button
            bgColor="#DCFCE7"
            color={AppColors.BLACK_TEXT_SECONDARY}
            borderRadius="8px"
            paddingX="16px"
            disabled
          >
            <Check color={AppColors.GREEN_PRIMARY} />
            Diferencia agregada
          </Button>
          <Button
            bgColor={AppColors.ERROR_TEXT}
            color={AppColors.WHITE_SECONDARY}
            paddingX="16px"
            onClick={() => setOpenHADifferenceModal(true)}
            disabled={loadingCreate || haDifferenceAbs <= 0}
          >
            + Modificar diferencia
          </Button>
        </Flex>
      ) : (
        <Button
          bgColor={AppColors.ERROR_TEXT}
          color={AppColors.WHITE_SECONDARY}
          paddingX="16px"
          onClick={() => setOpenHADifferenceModal(true)}
          disabled={loadingCreate || haDifferenceAbs <= 0}
        >
          + Agregar motivo de diferencia de hectareas
        </Button>
      )}
    </Flex>
  );
};
